import styles from './statusDot.module.css';

interface IStatusDotProps {
  color: string; // Dot fill — pass a design token, e.g. `var(--blue)`
  size?: number;
  animate?: boolean; // Adds the soft pulse used for "live"/"active" states
  className?: string;
}

/**
 * Generic status dot — a filled circle with an optional pulse. Colour is
 * caller-supplied (a design token) so the same dot effect can be reused
 * across surfaces (equipment, cameras, …) without baking statuses in.
 */
export function StatusDot({ color, size = 7, animate = false, className }: IStatusDotProps) {
  return (
    <span
      className={[styles.dot, className].filter(Boolean).join(' ')}
      data-animate={animate}
      style={{ width: size, height: size, background: color }}
      aria-hidden
    />
  );
}
